/** @format */

// components/ViewManager.jsx
import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import CustomersList from "../Pages/Customers/CustomersList";
import Registers from "../Pages/Registers";
import Discounts from "../Pages/Discounts";
import ProductListContainer from "../Pages/Products";
import { useSelector, useDispatch } from "react-redux";
import { closeView } from "../ReduxToolkit/Reducers/viewReducer";
import SettingsPage from "../Pages/Settings";
import CategoryPage from "../Pages/Applications/ECommerce/CategoryPage";
import ProductAddons from "../Pages/Products/Addons";
import ReportsHome from "../Pages/Reports";
import PrintersPage from "../Pages/Printers";
import CashierList from "../Pages/Cashier/CashierList";
import PaymentTypes from "../Pages/PaymentTypes";
import RegisterForm from "../Pages/Auth/Register/RegisterForm";
import ShortcodeModal from "../Pages/Shortcode";
import { ShortCodes } from "../Utils/Constants";
import ShortCode from "./Header/RightHeader/ShortCode";
import AddProduct from "../Pages/Products/AddProduct";
import EndDay from "../Pages/EndDay";
import CloseReports from "../Pages/Reports/CloseReport";
import CloseReportDetails from "../Pages/Reports/CloseDetailReport";
import AddCustomers from "../Pages/Customers";
import AddCashier from "../Pages/Cashier";
import SetRegisterAmountView from "../Pages/POS/SetRegisterAmountView";
import EndDayReports from "../Pages/Reports/EOD";
import EODSummary from "../Pages/Reports/EOD/EODSummary";
import EODByCategory from "../Pages/Reports/EOD/EODByCategory";
import EODByPayTypes from "../Pages/Reports/EOD/EODByPayTypes";
import TransactionReports from "../Pages/Reports/TransactionReports";
import SalesReportByUser from "../Pages/Reports/SalesReportByUser";
import SalesReportByItems from "../Pages/Reports/SalesReportByItems";
import SalesReportByCategory from "../Pages/Reports/SalesReportByCategories";
import SalesTaxReport from "../Pages/Reports/SalesTaxReport";
import SalesReportByPlatform from "../Pages/Reports/SalesReportByPlatform";
import StockReport from "../Pages/Reports/StockReport";
import VariableProductFormView from "../Pages/Products/VariableProductFormEdit";
import TierDiscounts from "../Pages/Settings/Data/TierDiscounts";
import OrdersHistory from "../Pages/Orders/History";
import OrderInvoice from "../Pages/Orders/Invoice";
import PrivateChatContainer from "../Components/Applications/Chat/PrivateChat";
import PayCart from "../Pages/POS/Pay";
import { backToCart } from "../ReduxToolkit/Reducers/CartReducer";
import ExternalInventory from "../Pages/ExternalInventory";
import RegisterSummary from "../Pages/Registers/RegisterSummary";
import StockZeroReport from "../Pages/Reports/StockZeroReport";
import RoundsReport from "../Pages/Reports/RoundsReport";

import { FaArrowLeft } from "react-icons/fa";
import { openView } from "../ReduxToolkit/Reducers/viewReducer";

export default function ViewManager() {
  const dispatch = useDispatch();
  const { activeView, params } = useSelector((state) => state.view);
  const {
    register_id,
    customer_id,
    cashier_id,
    eod_id,
    product_id,
    product,
    order_id,
    backTo,
  } = params;

  const renderView = () => {
    switch (activeView) {
      case "chat":
        return <PrivateChatContainer />;
      case "customers":
        return <CustomersList />;
      case "customers_new":
        return <AddCustomers customer_id={null} />;
      case "customers_edit":
        return <AddCustomers customer_id={customer_id} />;
      case "registers":
        return <Registers backTo={backTo} />;
      case "discounts":
        return <Discounts />;
      case "orders":
        return <OrdersHistory />;
      case "orders_invoice":
        return <OrderInvoice order_id={order_id} />;
      case "tier_discounts":
        return <TierDiscounts />;
      case "products":
        return <ProductListContainer />;
      case "new_product":
        return <AddProduct />;
      case "products_edit":
        return <AddProduct product_id={product_id} />;
      case "products_edit_variable":
        return <VariableProductFormView product={product} />;
      case "settings":
        return <SettingsPage />;
      case "end_day":
        return <EndDay />;
      case "reports":
        return <ReportsHome />;
      case "reports_close":
        return <CloseReports backTo={backTo} />;
      case "reports_close_detail":
        return <CloseReportDetails register_id={register_id} />;
      case "reports_eod":
        return <EndDayReports showLatest={params?.showLatest} eodData={params?.eodData} backTo={backTo} />;
      case "reports_eod_summary":
        return <EODSummary register_id={eod_id} />;
      case "reports_eod_category":
        return <EODByCategory register_id={eod_id} />;
      case "reports_eod_paytypes":
        return <EODByPayTypes register_id={eod_id} />;
      case "reports_transactions":
        return <TransactionReports backTo={backTo} />;
      case "reports_sales_user":
        return <SalesReportByUser backTo={backTo} />;
      case "reports_sales_item":
        return <SalesReportByItems backTo={backTo} />;
      case "reports_sales_category":
        return <SalesReportByCategory backTo={backTo} />;
      case "reports_sales_tax":
        return <SalesTaxReport backTo={backTo} />;
      case "reports_sales_platform":
        return <SalesReportByPlatform backTo={backTo} />;
      case "reports_stock":
        return <StockReport backTo={backTo} />;
      case "reports_stock_zero":
        return <StockZeroReport backTo={backTo} />;
      case "reports_rounds":
        return <RoundsReport backTo={backTo} />;
      case "categories":
        return <CategoryPage />;
      case "addons":
        return <ProductAddons />;
      case "payment-types":
        return <PaymentTypes />;
      case "printers":
        return <PrintersPage />;
      case "cashiers":
        return <CashierList />;
      case "cashiers_new":
        return <AddCashier cashier_id={null} />;
      case "cashiers_edit":
        return <AddCashier cashier_id={cashier_id} />;
      case "set_register_amount":
        return <SetRegisterAmountView />;
      case "shortcode":
        return <ShortCode />;
      case "pay_cart":
        return <PayCart minimal={true} />;
      case "external_inventory":
        return <ExternalInventory />;
      case "close_register_summary":
        return <RegisterSummary register_id={register_id} backTo={backTo} />;

      default:
        return null;
    }
  };

  const getModalTitle = () => {
    switch (activeView) {
      case "chat":
        return "Chat";
      case "customers":
        return "Customers";
      case "customers_new":
        return "Add Customer";
      case "customers_edit":
        return "Edit Customer";
      case "registers":
        return "Registers";
      case "discounts":
        return "Discounts";
      case "orders":
        return "Orders History";
      case "orders_invoice":
        return "Order Invoice";
      case "tier_discounts":
        return "Tier Discounts";
      case "products":
        return "Products";
      case "new_product":
        return "Add Product";
      case "products_edit":
        return "Edit Product";
      case "products_edit_variable":
        return "Edit Variable Product";
      case "settings":
        return "Settings";
      case "end_day":
        return "End Day";
      case "reports":
        return "Reports";
      case "reports_close":
        return "Close Reports";
      case "reports_close_detail":
        return "Close Report Details";
      case "reports_eod":
        return "End of Day Reports";
      case "reports_eod_summary":
        return "EOD Summary";
      case "reports_eod_category":
        return "EOD by Category";
      case "reports_eod_paytypes":
        return "EOD by Payment Types";
      case "reports_transactions":
        return "Transaction Reports";
      case "reports_sales_user":
        return "Sales Report by User";
      case "reports_sales_item":
        return "Sales Report by Items";
      case "reports_sales_category":
        return "Sales Report by Category";
      case "reports_sales_tax":
        return "Sales Tax Report";
      case "reports_sales_platform":
        return "Sales Report by Platform";
      case "reports_stock":
        return "Stock Report";
      case "reports_stock_zero":
        return "Stock Zero Report";
      case "reports_rounds":
        return "Government Rounding Report";
      case "categories":
        return "Categories";
      case "addons":
        return "Product Add-ons";
      case "payment-types":
        return "Payment Types";
      case "printers":
        return "Printers";
      case "cashiers":
        return "Cashiers";
      case "cashiers_new":
        return "Add Cashier";
      case "cashiers_edit":
        return "Edit Cashier";
      case "set_register_amount":
        return "Set Register Amount";
      case "shortcode":
        return "Shortcodes";
      case "pay_cart":
        return "Payment";
      case "external_inventory":
        return "External Inventory";
      case "close_register_summary":
        return "Register Summary";
      default:
        return "View";
    }
  };

  const handleCloseView = () => {
    if (activeView === "pay_cart") {
      dispatch(backToCart());
    }
    dispatch(closeView());
  };

  return (
    <Modal
      isOpen={!!activeView}
      toggle={() => dispatch(closeView())}
      size="xl"
      scrollable
      backdrop="static"
    >
      <ModalHeader toggle={handleCloseView}>
        {backTo && activeView !== "reports" && (
          <FaArrowLeft
            style={{ cursor: "pointer", marginRight: "10px" }}
            onClick={() => dispatch(openView(backTo))}
          />
        )}
        {getModalTitle()}
      </ModalHeader>
      <ModalBody>{renderView()}</ModalBody>
    </Modal>
  );
}
